import store from '@sb/store'
var sb = require('@sb/util')

import ConvoList from './ConvoList.js'
import Convo from './Convo.js'

export default {
	name: 'widget',
	props: ['convoKey', 'view', 'isShow', 'forceMode'],
	// view: chat, list
	// forceMode: chat, form, prechat, offline
	data () {
		return {
			...store.bind(this, ['convoM']),
		}
	},

	render () {
		if (this.view === 'list' && sb.size(this.convoM) > 0) {
			return <ConvoList isShow={this.isShow} vOn:go={this.goToConvo} vOn:close={() => this.$emit('close')} />
		}

		return (
			<Convo
				isShow={this.isShow}
				convoKey={this.convoKey}
				forceMode={this.forceMode}
				vOn:close={() => this.$emit('close')}
				vOn:go={this.goToList}
			/>
		)
	},

	methods: {
		goToList () {
			this.$emit('go', {view: 'list'})
		},
		goToConvo (key) {
			this.$emit('go', {view: 'chat', convoKey: key})
		},
	},
}
